import { setup } from '@cc/calculator/src/worker';

onmessage = setup();
